import React, { Component } from 'react'

import './pincode.scss'

class PinCode extends Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.getClass = this.getClass.bind(this)
  }

  getClass (key) {
    let { pin } = this.props
    console.log('pin length ', pin.length, pin)

    let className = 'pin-circle'
    if (key === pin.length) {
      className += ' active'
    } else if (key < pin.length) {
      className += ' filledout'
    }
    return className
  }

  render () {
    return (
      <div className='element-pincode'>
        <div className='pin-digit'><div className={this.getClass(0)} /></div>
        <div className='pin-digit'><div className={this.getClass(1)} /></div>
        <div className='pin-digit'><div className={this.getClass(2)} /></div>
        <div className='pin-digit'><div className={this.getClass(3)} /></div>
      </div>
    )
  }
}

export default PinCode



// WEBPACK FOOTER //
// ./src/app/shared/elements/pinCode/index.js